import React, {useRef, useEffect} from 'react'
import PropTypes from 'prop-types'

function ChatInput({isDisabled, testid, name, onChangeHandle, onKeyDown, placeholder, value}) {
  const maximumMessageLength = 5000
  const inputElement = useRef(null)

  useEffect(() => {
    if (inputElement.current && !isDisabled) {
      inputElement.current.focus()
    }
  }, [isDisabled])

  return (
    <div className="input">
      <label htmlFor="chat_message_input">
        <input
          id="chat_message_input"
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          autoComplete="off"
          data-testid={testid}
          disabled={isDisabled}
          name={name}
          maxLength={maximumMessageLength}
          onKeyDown={onKeyDown}
          onChange={onChangeHandle}
          placeholder={placeholder}
          value={value}
          type="text"
          ref={inputElement}
        />
      </label>
    </div>
  )
}
ChatInput.propTypes = {
  isDisabled: PropTypes.bool,
  testid: PropTypes.string,
  name: PropTypes.string,
  onChangeHandle: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.any,
}

export default ChatInput
